import React from "react";
import team from "../img/team.jpg";
function Info() {
  return (
    <section
      className="grid grid-cols-1 md:grid-cols-2 gap-2 w-full "
      id="aqua"
    >
      <div className="py-2 flex-1 flex items-center relative">
        {
          <img
            src={team}
            className="ml-auto h-420 w-full lg:w-auto lg:h-300"
            alt="img"
          />
        }
      </div>
      <div className="py-2 flex-1 flex flex-col items-start justify-center gap-6">
        <p className="text-[2rem] lg:text-[2rem] font-bold tracking-wide text-slate-700">
        Know How Your Food Grows
        </p>
        <p className="text-base text-slate-400 text-center md:text-left md:w-[80%]">
        Meet the team of engineering students who developed an innovative product named "HYDRAMATSYAPALAN" to solve the problem of all the fish farmer's out there . This group of students harnessed their collective skills in design, coding, and hardware development to create a cutting-edge solution to a real-world problem that is the water quality management issue while fish breeding and wastage of gallons of water while cleaning the tanks .
 The team successfully showcased their product in various project competitions like:- 
CIIA 2022 ( Among the top 100 exhibitors in Nehru science center , Mumbai) 
TECH4GOOD 2022 (National level Project Competition)
HYDRAMATSYAPALAN was developed by team of students  [ Farheen Khan , Arunkumar Mariappan , Heeral Chumber , Riddhi Joshi ] from department of Electronics and Telecommunication from Vivekanand education society's institute of technology, Chembur.
 Our team was formed with the goal of participating in a prestigious project competition, and we worked tirelessly to develop a product that we are proud of. Our diverse backgrounds and areas of expertise allowed us to approach the project from multiple angles, leading to a unique and effective solution.
Throughout the competition, we demonstrated not only our technical skills, but also our ability to work collaboratively and communicate effectively. With the total support and guidance of our Mentor MS. ASHWINI SAWANT , we were able to achieve our goals. 
We believe in using engineering to address real-world challenges and improve the lives of people around us.
        </p>
      </div>
    </section>
  );
}

export default Info;
